import React from 'react';
import { events, quickAccess } from '../data/homepage';
export function Events() {
  return <section aria-labelledby="events-title" className="relative overflow-hidden bg-ville-navy" data-id="element-1136" data-mp="2c8gnofpe5mbd">
      <svg aria-hidden="true" viewBox="0 0 400 600" preserveAspectRatio="none" className="pointer-events-none absolute -right-10 top-0 hidden h-full w-[420px] lg:block" data-id="element-1137" data-mp="2gz6ulxdgtx86">
        <path d="M420,40 C300,120 360,220 270,300 C180,380 260,470 150,560" fill="none" stroke="#2fe1a0" strokeWidth="2" opacity="0.35" data-id="element-1138" data-mp="1p9are2sv31ny" />
      </svg>

      <div className="relative mx-auto grid max-w-[1400px] gap-12 px-5 pb-20 pt-8 lg:grid-cols-[minmax(0,34%)_minmax(0,1fr)] lg:gap-16 lg:px-10" data-id="element-1139" data-mp="1y85wfbk665po">
        <div data-id="element-1140" data-mp="235xny4gwjptc">
          <p className="text-center font-display text-lg font-extrabold text-white lg:text-right" data-id="element-1141" data-mp="39ocozq5z6vb2">
            What’s Happening
          </p>
          <h2 id="events-title" className="mt-1 text-center font-display text-4xl font-extrabold leading-tight tracking-tight text-ville-lime sm:text-5xl lg:text-right" data-id="element-1142" data-mp="3eme4k1470chs">
            Upcoming Events
          </h2>

          <ul className="mt-8 space-y-5" data-id="element-1143" data-mp="2fpmdo8xfg69c">
            {events.map(event => <li key={event.id} className="flex items-start gap-4" data-id="element-1144" data-mp="2augxzrumbntp">
                <span className="grid h-[62px] w-[62px] shrink-0 place-content-center rounded-md border border-white/40 text-center leading-none" data-id="element-1145" data-mp="25shr47zo68s0">
                  <span className="text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-1146" data-mp="1w3hqyl9fl7c8">{event.month}</span>
                  <span className="mt-1 font-display text-2xl font-extrabold text-ville-lime" data-id="element-1147" data-mp="1s1mq1hvewvyz">{event.day}</span>
                </span>
                <span className="min-w-0" data-id="element-1148" data-mp="1n431np5032tb">
                  <span className="block text-sm text-white/90" data-id="element-1149" data-mp="1n0yqu8x158to">{event.time}</span>
                  <a href="#accueil" className="mt-1 block font-display text-[17px] font-extrabold leading-snug text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1150" data-mp="1i5t63dfd6076">
                    {event.title}
                  </a>
                </span>
              </li>)}
          </ul>

          <p className="mt-7" data-id="element-1151" data-mp="yiybflfmvidy">
            <a href="#accueil" className="text-[15px] font-semibold text-white underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-spring hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1152" data-mp="yjzofvg7meyb">
              View Calendar
            </a>
          </p>
        </div>

        <div data-id="element-1153" data-mp="1hfptxsncptgy">
          <p className="text-center font-display text-lg font-extrabold text-white lg:text-left" data-id="element-1154" data-mp="1hf7y2x4lph9k">
            Looking For Something?
          </p>
          <h2 className="mt-1 text-center font-display text-4xl font-extrabold tracking-tight text-ville-lime sm:text-5xl lg:text-left" data-id="element-1155" data-mp="29wtrqxi9xx6r">
            Quick Access
          </h2>

          <div className="mt-8 grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-1156" data-mp="3ul4k1vri27x2">
            {quickAccess.map(group => <section key={group.title} aria-labelledby={`quick-${group.title}`} data-id="element-1157" data-mp="87wjkrpopgvf">
                <h3 id={`quick-${group.title}`} className="font-display text-xl font-extrabold tracking-tight text-white" data-id="element-1158" data-mp="89qwbiqsy2of">
                  {group.title}
                </h3>
                <ul className="mt-2.5 list-disc space-y-1.5 pl-5 marker:text-ville-spring" data-id="element-1159" data-mp="36q1v7nsp44gl">
                  {group.links.map(link => <li key={link} data-id="element-1160" data-mp="3lodqbq0f755n">
                      <a href="#accueil" className="text-[15px] text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1161" data-mp="3gnppkcme39y8">
                        {link}
                      </a>
                    </li>)}
                </ul>
              </section>)}
          </div>
        </div>
      </div>
    </section>;
}